<span class="highlight" v-html="highlighted"></span>